<!-- static content data from lang: error -->
<template>
  <div class="container h-100">
    <div class="h-100">
      <div class="d-flex justify-content-center align-items-center h-100">
      <div class="base-screen">
      <b-card class="p-3">
        <div class="error-message text-center">
          <h3 class="mt-0 mb-4">Ooops!</h3>
          <p class="mb-4">Page not found. Don't worry though, we have plenty of other pages to explore</p>
          <div class="">
            <b-btn variant="primary" class="mr-3" @click="previousRoute()">{{lang.label.buttons.back}}
             
            </b-btn>
            <b-btn variant="primary"> <router-link to="/home" style="color:#FFF">{{lang.label.buttons.home}}
                </router-link>
            </b-btn>
          </div>
        </div>

      </b-card>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      lang: this.$lang.error,
    };
  },
  methods: {
      previousRoute(){
//          const link = this.$router.getPrevLink(); // function is not exist?
   return this.$router.go(-1);
      }
      
  }
  
}
</script>

